import { global } from ":shared/app";

export type GET = {
  returns: {
    team_name: string;
    track: string;
    status: "In-Complete" | "Completed" | "Active";
    image: string;
    members: { name: string; email: string; role?: string; image: string }[];
  }[];
};

export const endpoint = "teaming/explore/teams/";

export async function get(): Promise<GET["returns"]> {
  // return Promise.resolve(import("./teams.mocks")).then((r) => {
  //   return r.success;
  // });
  return global.api
    .getAuth(endpoint)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => {
      return Promise.reject(err.message);
    });
}
